/*
    ELECTRON GAMES REGISTRY
*/

/* Card Row Presets */
const singleBox = [
    { title: "Dealer Cards", type: "dealer", box: 0, result: true },
    { title: "Player Cards", type: "player", box: 1, result: true },
]

const twoBoxes = [
    { title: "Dealer Cards", type: "dealer", box: 0, result: true },
    { title: "BOX 1", type: "player", box: 1, result: true },
    { title: "BOX 2", type: "player", box: 2, result: true },
]

const twoBoxesWithAdditional = [
    ...twoBoxes,
    { title: "Additional Cards", type: "additional", box: 0, result: false, container: "additional" },
]


/* Defaults */
const defaults = {
    boxes: false,
    /* One row per box in "{PREFIX}GamePlayers" — such a round holds no single player of its own */
    multibox: false,
    process: 1,
    currency: "default",
    socket: "admin",
    hideEmpty: false,
    cards: singleBox,
}


/* Games */
const list = [
    {
        key: "rep",
        route: "russian-electron-poker",
        name: "Русский Электронный Покер",
        process: 2,
    },
    {
        key: "r2ep",
        route: "russian-two-box-electron-poker",
        name: "Русский 2 BOX Электронный Покер",
        boxes: true,
        process: "boxes",
        cards: twoBoxes,
    },
    {
        key: "sep",
        route: "super-electron-poker",
        name: "Cупер Покер",
    },
    {
        key: "oep",
        route: "open-electron-poker",
        name: "Открытый Электронный Покер",
        boxes: true,
        process: "boxes",
        cards: twoBoxes,
    },
    {
        key: "qep",
        route: "queen-electron-poker",
        name: "Электронный Пиковая Дама",
        boxes: true,
        process: "boxes",
        cards: twoBoxes,
    },
    {
        key: "uep",
        route: "ultimate-electron-poker",
        name: "Электронный Ultimate Texas Hold'em",
        boxes: true,
        process: "boxes",
        /* Ultimate deals the community cards on top of the boxes */
        cards: twoBoxesWithAdditional,
    },
    {
        key: "eep",
        route: "european-electron-poker",
        name: "Электронный Европейский Покер",
        boxes: true,
        process: "boxes",
        cards: twoBoxes,
    },
    {
        key: "hep",
        route: "casino-holdem-electron-poker",
        name: "Электронный Casino Hold'em",
        boxes: true,
        /* Casino Hold'em always shows both boxes in the process table */
        process: 2,
        cards: twoBoxesWithAdditional,
    },
    {
        key: "nep",
        route: "nova-electron-poker",
        name: "Электронный NOVA POKER",
        boxes: true,
        process: "boxes",
        cards: twoBoxes,
    },
    {
        key: "jep",
        route: "j-electron-poker",
        name: "Русский J Покер",
        /* J Poker adds the joker that was dealt to the round */
        cards: [
            ...singleBox,
            { title: "Joker", type: "joker", box: 0, result: false },
        ],
    },
    {
        key: "eb1",
        route: "blackjack-one-electron",
        name: "Электронный Blackjack ONE",
        process: 2,
        currency: "blackjack",
        /* Splits and side bets only exist in some rounds */
        hideEmpty: true,
        cards: [
            { title: "Dealer Cards", type: "dealer", box: 0, result: true },
            { title: "Player Cards", type: "player", box: 1, result: true },
            { title: "Hand 1", type: "hand-1", box: 1, result: true },
            { title: "Hand 2", type: "hand-2", box: 2, result: true },
            { title: "PERFECT PAIR", type: "perfectpair", box: 1, result: true },
            { title: "21+3", type: "twentyone", box: 1, result: true },
        ],
    },
    {
        key: "eb5",
        route: "electron-blackjack-five-box",
        name: "Электронный Blackjack FIVE",
        /* Five boxes per round, the players live in EB5GamePlayers */
        multibox: true,
        process: 2,
        currency: "blackjack",
        hideEmpty: true,
        cards: [
            { title: "Dealer Cards", type: "dealer", box: 0, result: true },
            { title: "Player Cards", type: "player", box: 1, result: true },
        ],
    },
    {
        key: "eab",
        route: "electron-andar-bahar",
        name: "Электронный Andar Bahar",
        /* Andar Bahar has no dealer or player hand, only the joker and the two sides */
        cards: [
            { title: "Joker", type: "main", box: 0, result: false },
            { title: "Andar", type: "andar", box: 0, result: false },
            { title: "Bahar", type: "bahar", box: 0, result: false },
        ],
    },
    {
        key: "epb",
        route: "electron-punto-banco",
        name: "Электронный Punto Banco",
        process: 2,
        currency: "blackjack",
        /* Punto Banco game server authorises the admin socket by type */
        socket: "type",
        hideEmpty: true,
        cards: [
            { title: "Banker Cards", type: "banker", box: 0, result: true },
            { title: "Player Cards", type: "player", box: 1, result: true },
        ],
    },
]

/* Apply Defaults */
const games = list.map((game) => ({ ...defaults, ...game }))

/* Find A Game By Its Backend Key */
const find = (key) => games.find((game) => game.key === key) || null

/* Find A Game By The Key Of The Catalogue — the very same one Tables.game holds */
const findByRoute = (route) => games.find((game) => game.route === route) || null

export { games, find, findByRoute }
